import styled from "styled-components";

export const CustomLabelWrapper = styled.div`
  display: flex;
  gap: 4px;
`
